import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'

import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'

import { createColumns } from './columns.description'
import { createColumns as createFavoriteColumns } from './columnsFavorite.columns.description'
import BeneficiariesComponent from './component'

export default combine(
  withTableController({ id: 'beneficiaries-table' }),
  withTableController({ id: 'favorite-beneficiaries-table' }),
  withContext(
    'memberService',
    ServicesContext,
    ({ memberService }) => memberService
  ),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withContext(
    'taxonomyService',
    ServicesContext,
    ({ taxonomyService }) => taxonomyService
  ),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withMemo('favoriteColumns', () => createFavoriteColumns(), []),
  withCallbacks(
    {
      loadBeneficiaries:
        ({ memberService }) =>
          async (tableState, _table, query) =>
            await memberService.queryBeneficiaries({
              beneficiaryName: query?.beneficiaryName,
              categories: query?.categories,
              subCategories: query?.subCategories,
              page: tableState.page,
              size: tableState.pageSize,
            }),

      loadFavoriteBeneficiaries:
        ({ followerService }) =>
          async (tableState) =>
            await followerService.getBeneficiariesFollowers({
              page: tableState.page,
              size: tableState.pageSize,
            }),

      loadCategories:
        ({ taxonomyService }) =>
          async () =>
            await taxonomyService.queryBeneficiaryCategories(),

      onSearch:
        ({ table }) =>
          (query) => {
            table.search(query)
          },
    },
    []
  )
)(BeneficiariesComponent)
